export const COLORS = {
  primary: "#FFFFFF",
  secondary: "#000000",
  accent: "#944BBB",

  gray: "#3F3F3F",
};
